export default __webpack_public_path__ + "static/media/resultados_prueba.a9915a00.pdf";